module.exports = __webpack_public_path__ + "img/light2.13f4175d.png";